import { render } from "./disclaimers.vue?vue&type=template&id=5b02bb8b&scoped=true"
import script from "./disclaimers.vue?vue&type=script&lang=js"
export * from "./disclaimers.vue?vue&type=script&lang=js"

import "./disclaimers.vue?vue&type=style&index=0&id=5b02bb8b&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b02bb8b"]])

export default __exports__